import React from "react";

export default class TextToSpeechSettings extends React.Component {
  renderToggle() {
    return (
      <div className="setting-group text-to-speech-option">
        <div className="setting">
          <div className="header">Auto-Play</div>
        </div>
        <div className="setting-controls">
          <div className="btn-group" role="group" aria-label="Text-to-speech auto-play">
            {this.props.renderBtnGroupBtn('textToSpeech', 'on', this.props.textToSpeech, 'On')}
            {this.props.renderBtnGroupBtn('textToSpeech', 'off', this.props.textToSpeech, 'Off')}
          </div>
        </div>
      </div>
    );
  }

  renderLoopingToggle() {
    return (
      <div className="setting-group text-to-speech-option">
        <div className="setting">
          <div className="header">Loop</div>
          <div className="description">(sentence audio will play on repeat for chorusing)</div>
        </div>
        <div className="setting-controls">
          <div className="btn-group" role="group" aria-label="Text-to-speech looping">
            {this.props.renderBtnGroupBtn('textToSpeechLooping', 'on', this.props.textToSpeechLooping, 'On')}
            {this.props.renderBtnGroupBtn('textToSpeechLooping', 'off', this.props.textToSpeechLooping, 'Off')}
          </div>
        </div>
      </div>
    );
  }

  renderSystemVoices() {
    if(this.props.clozemasterTtsAvailable && this.props.clozemasterTextToSpeech === 'on') {
      return null;
    }

    if(!this.props.systemTtsAvailable) {
      return null;
    }

    return (
      <div className="setting-group text-to-speech-option">
        <div className="setting">
          <div className="header">System Voice</div>
        </div>
        <div className="setting-controls">
          <select className="form-control" name="system_voice" value={this.props.textToSpeechVoice} onChange={(e) => this.props.onVoiceSelected(e.target.value)}>
            <option value="random">Random</option>
            {this.props.systemTtsVoices.map((voice) => (
              <option value={voice.name} key={voice.voiceURI || voice.name}>{voice.lang} {voice.id} {voice.name}</option>
            ))}
          </select>
        </div>
      </div>
    );
  }

  renderControls() {
    if(this.props.clozemasterTtsAvailable || this.props.systemTtsAvailable) {
      return (
        <>
          {this.renderToggle()}
          {this.renderLoopingToggle()}
          {this.renderClozemasterTtsToggle()}
          {this.renderSystemVoices()}
          {this.renderSpeedControl()}
        </>
      );
    }

    return (
      <div className="no-voices">
        <em>There are currently no voices available for {this.props.targetLanguageName} on your browser/device. Text-to-speech works best on Chrome and Safari for desktop.</em>
      </div>
    );
  };

  renderClozemasterTtsToggle() {
    if(!this.props.clozemasterTtsAvailable || !this.props.systemTtsAvailable) {
      return null;
    }

    return (
      <div className="setting-group use-clozemaster-voice">
        <div className="setting">
          <div className="header">Use Clozemaster Voice</div>
        </div>
        <div className="setting-controls">
          <div className="btn-group" role="group" aria-label="Use Clozemaster text-to-speech">
            {this.props.renderBtnGroupBtn('clozemasterTextToSpeech', 'on', this.props.clozemasterTextToSpeech, 'On')}
            {this.props.renderBtnGroupBtn('clozemasterTextToSpeech', 'off', this.props.clozemasterTextToSpeech, 'Off')}
          </div>
        </div>
      </div>
    );
  }

  renderSpeedControl() {
    const speed = parseFloat(this.props.textToSpeechSpeed);

    return (
      <div className="setting-group text-to-speech-option" style={{ display: 'block' }}>
        <div className="setting">
          <div className="header">Speed</div>
        </div>
        <div className="setting-controls">
          <div className="text-to-speech-speed">
            <div className="btn-group" data-toggle="buttons" aria-label="Text-to-speech speed">
              {[0.5, 0.75, 1, 1.25, 1.5, 2].map((s) => (
                this.props.renderBtnGroupBtn('textToSpeechSpeed', s, speed, s + 'x')
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <>
        {this.renderControls()}
      </>
    );
  }
};
